package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.WikipediaSimpleIcons: ImageVector
    get() {
        if (_wikipediaSimpleIcons != null) {
            return _wikipediaSimpleIcons!!
        }
        _wikipediaSimpleIcons = Builder(name = "WikipediaSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(12.09f, 13.12f)
                curveToRelative(-0.94f, 1.93f, -2.22f, 4.55f, -2.85f, 5.73f)
                curveToRelative(-0.62f, 1.07f, -1.13f, 0.93f, -1.53f, 0.03f)
                curveToRelative(-1.41f, -3.32f, -4.29f, -9.14f, -5.65f, -12.41f)
                curveToRelative(-0.25f, -0.60f, -0.44f, -0.99f, -0.62f, -1.14f)
                curveToRelative(-0.18f, -0.15f, -0.55f, -0.24f, -1.12f, -0.27f)
                curveTo(0.10f, 5.03f, 0.0f, 4.98f, 0.0f, 4.90f)
                verticalLineToRelative(-0.46f)
                lineToRelative(0.05f, -0.05f)
                curveToRelative(0.92f, -0.01f, 5.40f, 0.0f, 5.40f, 0.0f)
                lineToRelative(0.05f, 0.05f)
                verticalLineToRelative(0.43f)
                curveToRelative(0.0f, 0.12f, -0.08f, 0.18f, -0.23f, 0.18f)
                lineToRelative(-0.56f, 0.03f)
                curveToRelative(-0.49f, 0.03f, -0.73f, 0.16f, -0.73f, 0.44f)
                curveToRelative(0.0f, 0.14f, 0.05f, 0.33f, 0.17f, 0.60f)
                curveToRelative(1.08f, 2.65f, 4.82f, 10.52f, 4.82f, 10.52f)
                lineToRelative(0.14f, 0.05f)
                lineToRelative(2.41f, -4.81f)
                lineToRelative(-0.48f, -1.07f)
                lineToRelative(-1.66f, -3.26f)
                reflectiveCurveToRelative(-0.32f, -0.65f, -0.43f, -0.87f)
                curveToRelative(-0.73f, -1.44f, -0.71f, -1.52f, -1.45f, -1.62f)
                curveToRelative(-0.21f, -0.02f, -0.31f, -0.05f, -0.31f, -0.15f)
                verticalLineToRelative(-0.47f)
                lineToRelative(0.06f, -0.05f)
                horizontalLineToRelative(4.29f)
                lineToRelative(0.11f, 0.04f)
                verticalLineToRelative(0.45f)
                curveToRelative(0.0f, 0.11f, -0.08f, 0.15f, -0.23f, 0.15f)
                lineToRelative(-0.31f, 0.05f)
                curveToRelative(-0.79f, 0.06f, -0.66f, 0.38f, -0.14f, 1.42f)
                lineToRelative(1.58f, 3.25f)
                lineToRelative(1.76f, -3.50f)
                curveToRelative(0.29f, -0.64f, 0.23f, -0.80f, 0.11f, -0.95f)
                curveToRelative(-0.07f, -0.08f, -0.31f, -0.22f, -0.81f, -0.24f)
                lineToRelative(-0.20f, -0.02f)
                curveToRelative(-0.05f, 0.0f, -0.10f, -0.02f, -0.15f, -0.05f)
                curveToRelative(-0.05f, -0.03f, -0.07f, -0.08f, -0.07f, -0.13f)
                verticalLineToRelative(-0.43f)
                lineToRelative(0.06f, -0.05f)
                curveToRelative(1.25f, -0.01f, 4.04f, 0.0f, 4.04f, 0.0f)
                lineToRelative(0.06f, 0.05f)
                verticalLineToRelative(0.44f)
                curveToRelative(0.0f, 0.12f, -0.06f, 0.18f, -0.19f, 0.18f)
                curveToRelative(-0.65f, 0.03f, -0.78f, 0.10f, -1.02f, 0.44f)
                curveToRelative(-0.12f, 0.19f, -0.38f, 0.59f, -0.65f, 1.04f)
                lineToRelative(-2.30f, 4.27f)
                lineToRelative(-0.07f, 0.14f)
                lineToRelative(2.79f, 5.71f)
                lineToRelative(0.17f, 0.05f)
                lineToRelative(4.40f, -10.44f)
                curveToRelative(0.15f, -0.42f, 0.13f, -0.72f, -0.06f, -0.90f)
                curveToRelative(-0.20f, -0.17f, -0.35f, -0.27f, -0.86f, -0.30f)
                lineToRelative(-0.42f, -0.02f)
                curveToRelative(-0.06f, 0.0f, -0.11f, -0.01f, -0.15f, -0.05f)
                curveToRelative(-0.04f, -0.03f, -0.07f, -0.08f, -0.07f, -0.12f)
                verticalLineToRelative(-0.44f)
                lineToRelative(0.06f, -0.05f)
                horizontalLineToRelative(4.96f)
                lineToRelative(0.04f, 0.05f)
                verticalLineToRelative(0.44f)
                curveToRelative(0.0f, 0.12f, -0.07f, 0.18f, -0.21f, 0.18f)
                curveToRelative(-0.65f, 0.03f, -1.13f, 0.18f, -1.44f, 0.42f)
                curveToRelative(-0.31f, 0.26f, -0.56f, 0.62f, -0.74f, 1.07f)
                curveToRelative(0.0f, 0.0f, -4.04f, 9.26f, -5.43f, 12.34f)
                curveToRelative(-0.53f, 1.01f, -1.05f, 0.92f, -1.50f, -0.03f)
                curveToRelative(-0.57f, -1.17f, -1.77f, -3.79f, -2.65f, -5.71f)
                lineToRelative(0.05f, -0.04f)
                close()
            }
        }
        .build()
        return _wikipediaSimpleIcons!!
    }

private var _wikipediaSimpleIcons: ImageVector? = null
